import FileUploadInputComponent from "../../components/file/file-upload-input.component";
import { FILE_EXTENSIONS } from "../../config/constants";
import TESCOXMLInputModel from "../../models/tesco-xml-input/tesco-xml-input.model";
import ViewBase from "../view-base.view";

export default function TESCOXMLInput() {
    ViewBase.call(this);

    const FORM_ID = 'TESCOXMLUploadForm';
    const UPLOAD_INPUT_ID = 'TESCOXMLUploadInput';

    let uploadXml = null;
    let uploadResult = null;

    const upload = (e) => {
        // Form validation
        if (!this.validateForm(e)) {
          return false;
        }

        if (!uploadXml.size) {
            e.stopPropagation();
            this.showErrorMessage(this.getText('EM00000141', 'No records found.'))
            return;
        }

        this.showLoading();
        TESCOXMLInputModel.uploadXMLFileTESCO({
            fileName: uploadXml.name,
            uploadXml,
        })
            .then((result) => {
                if (result) {
                    uploadResult = result;
                    this.showMessage(this.getText('EM00000313', 'Upload Completed'), this.getText('EM00000004', 'Success'));
                }
            })
            .catch((error) => {
                this.handleError(error);
            })
            .finally(() => {
                this.hideLoading();
            });
    }

    return {
        view: () => {
            return [
                /* TABLE */
                m('.card',
                    m('.card-body.g-2',
                        m('.row.g-2',
                            m('label.col-2.col-form-label.h5.fw-bold',
                                { for: FORM_ID },
                                this.getText('LT00000943', 'XML')
                            ),
                            m('form.col-3.position-relative.needs-validation[novalidate]', { id: FORM_ID, onsubmit: upload },
                                m(FileUploadInputComponent, {
                                    id: UPLOAD_INPUT_ID,
                                    accept: FILE_EXTENSIONS.XML,
                                    required: true,
                                    onInput: (data) => { uploadXml = data; },
                                }),
                                m('.invalid-tooltip', this.getText('EM00000316', 'Please select a file')),
                            ),
                            m('.col-1',
                                m('button.btn.btn-primary[type="submit"]',
                                    { form: FORM_ID },
                                    this.getText('LT00000290', 'Upload')
                                )
                            ),
                            m('.w-100'),
                            uploadResult &&
                            [
                                m('p.h5.fw-bold',
                                    this.getText('LT00000794', 'Total record(s) inserted'),
                                    ': ',
                                    m('a.cursor-pointer.text-danger.text-decoration-underline', {
                                        onclick: () => { TESCOXMLInputModel.downloadResultFile(uploadResult?.insertedFileGUID, "TESCO_Upload_XML_Success") }
                                    }, uploadResult?.inserted)
                                ),
                                m('p.h5.fw-bold.g-2',
                                    this.getText('LT00000795', 'Total record(s) rejected'),
                                    ': ',
                                    m('a.cursor-pointer.text-danger.text-decoration-underline', {
                                        onclick: () => { TESCOXMLInputModel.downloadResultFile(uploadResult?.rejectedFileGUID, "TESCO_XML_Rejected") }
                                    }, uploadResult?.rejected)
                                )
                            ],
                        ),
                    )
                ),

                this.getBaseViews()
            ];
        }
    };
}